/**
 * @file: 移动cube
 * @author: xiaolong.huang@dmall.com
 */

import { findByCubeId, findParentCubeByCubeId, findParentIdByCubeId, findChildCubeByIndex, getCubeIndexInParent } from './baseQuery';
import { getChildCubeCount } from './cubeInfo';

/**
 * 移动cube
 */
export function moveCube(taskQueue: Array<CubeTreeMoveTask>): void {
    // 先移除需要移动的cube
    taskQueue.forEach((task: CubeTreeMoveTask): void => {
        let oldParent: CubeId = task.from.parent;
        let oldParentCube: CubeNode = findByCubeId(oldParent);
        let moveCube: CubeNode = findByCubeId(task.from.moveTarget);

        if (!moveCube) {
            return;
        }

        oldParentCube.remove(moveCube);
    });

    // 再插入
    taskQueue.forEach((task: CubeTreeMoveTask): void => {
        let moveCube: CubeNode = findByCubeId(task.from.moveTarget);
        let newParent: CubeNode = findByCubeId(task.to.parent);
        let insertIndex: number = 0;

        if (!newParent) {
            return;
        }

        if (task.to.insertBefore) {
            insertIndex = getCubeIndexInParent(task.to.insertBefore);
        }
        else {
            insertIndex = getChildCubeCount(task.to.parent);
        }

        newParent.cubes.splice(insertIndex, 0, moveCube);
        moveCube.parentId = task.to.parent;
    });
}
